import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewRequest: {
		id: 'servicedesk-request-details-panel.help-center.view-request',
		defaultMessage: 'View request in portal',
		description: 'Text to be displayed on the link to portal',
	},
});
